import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import LoanRemarksUpdateModalUI from './LoanRemarksUpdateModalUI.js'

class LoanRemarksUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      remarksId: this.props.selectedRemarksId,
      remarks: this.props.selectedRemarks || '',
      remarksError: null,
      action: this.props.selectedAction || '',
      actionError: null,
      actionStatus: this.props.selectedActionStatus || '',
      actionStatusError: null,
      dateISO: this.props.selectedActionDateISO || '',
      dateISOError: null,
    }
  }

  render() {
    let actionList = [
      { key: 'soft_letter', value: 'Soft letter to the borrower' },
      { key: 'notice_to_borrower', value: 'Notice to the borrower and/or counterparties/ vendors' },
      { key: 'cheque_nach', value: 'Cheque/NACH presentation' },
      { key: 'legal_notice', value: 'Legal notice U/s 138 NI/25 PSS Act' },
      { key: 'criminal_complaint', value: 'Criminal Complaint' },
      { key: 'pre_payment', value: 'Pre-payment/Acceleration Notice' },
      { key: 'notice_for_pledge', value: 'Notice for Pledge Invocation' },
      { key: 'demand_notice', value: 'Demand Notice' },
      { key: 'other_litigation', value: 'Other Litigation' },
      { key: 'settlement', value: 'Settlement' },
      { key: 'other', value: 'Other' },
    ]
    let actionStatusList = [
      { key: 'complied', value: 'Complied' },
      { key: 'not_complied', value: 'Not Complied' },
    ]
    return (
      <LoanRemarksUpdateModalUI
        context={this.props.context}
        loan={this.props.loan}
        legal={this.props.legal}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        remarks={this.state.remarks}
        onRemarksChange={(event) => { this.setState({ remarks: event.target.value }) }}
        remarksError={this.state.remarksError}
        setRemarksError={(error) => { this.setState({ remarksError: error }) }}
        //
        action={this.state.action}
        onActionChange={(event) => { this.setState({ action: event.target.value }) }}
        actionError={this.state.actionError}
        setActionError={(error) => { this.setState({ actionError: error }) }}
        actionList={actionList}
        //
        dateISO={this.state.dateISO}
        onDateISOChange={(selectedDateISO) => { this.setState({ dateISO: selectedDateISO }) }}
        dateISOError={this.state.dateISOError}
        setDateISOError={(error) => { this.setState({ dateISOError: error }) }}
        //
        actionStatus={this.state.actionStatus}
        onActionStatusChange={(event) => { this.setState({ actionStatus: event.target.value }) }}
        actionStatusError={this.state.actionStatusError}
        setActionStatusError={(error) => { this.setState({ actionStatusError: error }) }}
        actionStatusList={actionStatusList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.selectedRemarksId)
      return
    if (prevProps.selectedRemarksId != this.props.selectedRemarksId)
      this.setState({
        remarksId: this.props.selectedRemarksId,
        remarks: this.props.selectedRemarks,
        action: this.props.selectedAction,
        dateISO: this.props.selectedActionDateISO,
        actionStatus: this.props.selectedActionStatus
      })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/remarks/${this.state.remarksId}`,
      this.onSubmitCallback, {
      remarks: this.state.remarks,
      action: this.state.action,
      dateISO: this.state.dateISO,
      actionStatus: this.state.actionStatus
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick("noBusy")
      }, 10)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default LoanRemarksUpdateModalSF
